/**
 * SafeIntersections data loaders — wired into `safeintersectionsConfig.loaders`.
 * The crash-risk bands (`risk_band_lower` / `risk_band_upper`) ride along on the
 * summary's `Identify[0]`, where the calculator reads them.
 */

import { loadSummaryTables, loadSystemLayers } from '#lib/common/loaders.js';
import {
	EProduct,
	ESafeIntersectionsModule,
	type ISafeIntersectionsSummaryData
} from './interfaces';
import { SI_DATASET, buildSystemLayers as buildSISystemLayers } from './layers';
import { CRASHES_DATASET, withCrashes } from '#lib/apps/safesystem/context/layers.js';

export const loadSystem = (apiKey: string) =>
	loadSystemLayers(apiKey, [SI_DATASET, CRASHES_DATASET], withCrashes(buildSISystemLayers));

// Expects location + Identify + Prioritize.
export const loadSummary = async (apiKey: string): Promise<ISafeIntersectionsSummaryData> =>
	(await loadSummaryTables(
		apiKey,
		EProduct.SafeIntersections,
		SI_DATASET,
		[ESafeIntersectionsModule.Identify, ESafeIntersectionsModule.Prioritize],
		3
	)) as unknown as ISafeIntersectionsSummaryData;
